(function($,w){$(function(){"use strict";

    // Page Animations
    var PageAnimations = function( $opt ) { this.init( $opt ); }

    $.extend( PageAnimations.prototype,
    {
        init : function( $opt )
        {
            this.vars();
            this.events();
            this.load();
        }, // end init

        vars : function()
        {
            this.contrl = new ScrollMagic.Controller();
            this.header = $( '#head-section' );
        }, // end vars

        load : function()
        {
            this.headAnim();
            this.tagReplace();
            $( '#blog-sidebar' ).find( 'p.et_bloom_popup_input>input' ).attr( 'style', 'padding-left:0!important' );
        }, // end load

        events : function()
        {
            var $this = this;

            $( '#scroll-icon' ).on( 'click', function( e )
            {
                e.preventDefault();

                $this.slideHead();
            });
        }, // end events

        headAnim : function()
        {
            var tr = this.header,
                hd = tr.children( 'img' ),
                tl = new TimelineMax();

            tl
                .to( hd, 1, { y: '40%', autoAlpha: 0, ease: Power0.easeNone, }, 0 )
                .fromTo( tr.children( '.head-excerpt' ), .7, { y: '0%', autoAlpha: 1, ease: Power0.easeNone, }, { y: '300%', autoAlpha: 0, ease: Power0.easeNone, }, 0 )
                .fromTo( tr.children( '.inner-meta' ), .8, { autoAlpha: 1, ease: Power0.easeNone, }, { autoAlpha: 0, ease: Power0.easeNone, }, 0 );

            new $.ScrollMagic.Scene({
                triggerElement: tr,
                triggerHook: 0,
                duration: '60%',
            })
            .setTween( tl )
            .addTo( this.contrl );
        }, // end headAnim

        slideHead : function()
        {

            TweenMax.to( w, ( $( w ).height() / 1200 ), { scrollTo:{ y: $( '#sfl-breadcrumb' ), offsetY: ( $( w ).width() > 980 ? 127 : 1 ) }});

        }, // end slideHead

        tagReplace : function()
        {
            var targ = $( 'h2.et_bloom_success_message' );

            targ.replaceWith( '<h4 class="et_bloom_success_message">' + targ.html() +'</h4>');
        },  // end tagReplace
    }); // end PageAnimations

    new PageAnimations({});

});}( jQuery, window ));
